// extracted by mini-css-extract-plugin
export default {"small":"buildingManagement_small__Tm9G1","add_floor_button":"buildingManagement_add_floor_button__qk6Dk"};